module.exports = __webpack_public_path__ + "static/media/landing_bg.158b581d.jpg";